import { render } from "./DocumentationAboutPage.vue?vue&type=template&id=21c3699e&scoped=true"
import script from "./DocumentationAboutPage.vue?vue&type=script&lang=js"
export * from "./DocumentationAboutPage.vue?vue&type=script&lang=js"

import "./DocumentationAboutPage.vue?vue&type=style&index=0&id=21c3699e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c3699e"]])

export default __exports__